module.exports = __webpack_public_path__ + "img/a.43dbbd02.png";